import { createAction, createReducer, on, props } from '@ngrx/store';

import { WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';

export const setTurnoverOverviewSectionCounters = createAction(
  '[turnoverOverview] setTurnoverOverviewSectionCounters',
  props<PropertyTurnsCounter>()
);

export const clearTurnoverOverviewCounters = createAction('[turnoverOverview] clearTurnoverOverviewCounters');

export const turnoverOverviewFeatureKey = 'turnoverOverview';

export interface PropertyTurnsCounter {
  propertyId: number;
  counters: {
    [key in WorkflowStepEnumType]?: number;
  };
}

export interface TurnoverOverviewReducerState {
  sectionCounters: {
    [key: number]: PropertyTurnsCounter;
  };
}

export const initialState: TurnoverOverviewReducerState = {
  sectionCounters: {},
};

export const turnoverOverviewReducer = createReducer(
  initialState,
  on(setTurnoverOverviewSectionCounters, (state, action) => ({
    ...state,
    sectionCounters: { ...state.sectionCounters, [action.propertyId]: action },
  })),
  on(clearTurnoverOverviewCounters, (state, action) => ({
    ...state,
    sectionCounters: {},
  }))
);
